import { useEffect, useState } from 'react';
import { fetchStorefrontBrands } from '../lib/brands';
import { isSupabaseConfigured } from '../lib/supabaseClient';

export function useBrands() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(isSupabaseConfigured);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isSupabaseConfigured) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      setError('');
      try {
        const data = await fetchStorefrontBrands();
        if (!cancelled) setBrands(data);
      } catch (loadError) {
        if (!cancelled) {
          setBrands([]);
          setError(loadError.message || 'Could not load brands.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { brands, loading, error };
}
